import React, { useEffect, useState } from "react";
import {
  Button,
  Grid,
  IconButton,
  Snackbar,
  Box,
  Typography,
  Stack,
  Divider,
  OutlinedInput,
} from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import DataTable from "../../components/DataTable";
import Modal from "../../components/Modal";
import DisplayOrder from "./DisplayOrder";
import InfoIcon from "@mui/icons-material/Info";
import ClearIcon from "@mui/icons-material/Clear";
import axios from "axios";
import {
  convertUTCToLocal,
  downloadPDFUrl,
  getAccessToken,
  postPackingFormUrl,
  updateAmountPackingUrl,
  parseJwt,
} from "../../utils/Utils";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import LocationView from "../Form/LocationView";
import EditIcon from "@mui/icons-material/Edit";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import EditOrderModel from "./EditOrderModel";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import PrimaryLoader from "../../components/Loader/PrimaryLoader";

const Listing = () => {
  const [openModal, setOpenModal] = useState(false);
  const [openMapModal, setOpenMapModal] = useState(false);
  const [openOrderEditModel, setOpenOrderEditModel] = useState(false);
  const [orders, setOrders] = useState([]);
  const [ordersListPickupDate, setOrdersListPickupDate] = useState([]);
  const [previewData, setPreviewData] = useState();
  const [previewAddOns, setPreviewAddOns] = useState({
    singleLayerPacking: "",
    multiLayerPacking: "",
    unpacking: "",
    dismantling: "",
  });
  const [previewTotalCost, setPreviewTotalCost] = useState(0);
  const [locationData, setLocationData] = useState({
    from: "",
    to: "",
  });
  const [previousTotalCost, setPreviousTotalCost] = useState(0);
  const [orderId, setOrderId] = useState();
  const [editLoadType, setEditLoadType] = useState("");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
  });
  const [filterDate, setFilterDate] = useState();
  const [loading, setLoading] = useState(false);
  const [openCalendarModal, setOpenCalendarModal] = useState(false);
  const [calendarOrder, setCalendarOrder] = useState(null);
  const [openScheduleModal, setOpenScheduleModal] = useState(false);
  const [scheduleFilterText, setScheduleFilterText] = useState("");
  const [scheduleFromDate, setScheduleFromDate] = useState(null);
  const [scheduleToDate, setScheduleToDate] = useState(null);
  useEffect(() => {
    getOrders();
  }, []);

  useEffect(() => {
    if (orders.length > 0 && filterDate) {
      const filteredOrders = orders.filter((x) =>
        dayjs(x.pickupDate).isSame(filterDate, "day")
      );
      setOrdersListPickupDate(filteredOrders);
    } else if (
      orders.length > 0 &&
      (filterDate === null || filterDate === undefined)
    ) {
      setOrdersListPickupDate(orders);
    }
  }, [filterDate]);

  const getOrders = async () => {
    setLoading(true);
    const res = await axios.get(postPackingFormUrl, getAccessToken());
    if (res.data.status && res.data.resultCode === 200) {
      setLoading(false);
      setOrders(res.data.data);
    } else {
      setLoading(false);
    }
  };

  const handleCalendarOpen = (order) => {
    setCalendarOrder(order);
    setOpenCalendarModal(true);
  };
  const handleCalendarClose = () => {
    setOpenCalendarModal(false);
    setCalendarOrder(null);
  };

  var token = localStorage.getItem("token");
  let tokenDetail;
  if (token) {
    tokenDetail = parseJwt(token);
  }
  const Action = (params) => {
    return (
      <Grid>
        <IconButton onClick={() => handleInfo(params.data)}>
          <InfoIcon fontSize="small" />
        </IconButton>
        <IconButton
          onClick={() => {
            handlePDFDownload(params.data);
          }}
        >
          <PictureAsPdfIcon fontSize="small" sx={{}} />
        </IconButton>
        <IconButton onClick={() => handleMapOpen(params.data)}>
          <LocationOnIcon fontSize="small" />
        </IconButton>
        <IconButton onClick={() => handleCalendarOpen(params.data)}>
          <CalendarMonthIcon fontSize="small" />
        </IconButton>
        <IconButton onClick={() => handleEditOrderOpen(params.data)}>
          <EditIcon fontSize="small" style={{}} />
        </IconButton>
      </Grid>
    );
  };

  const handleMapOpen = (props) => {
    const locationData = {
      from: props.pickupLocationDetails.pickupLocation,
      to: props.dropLocationDetails.dropLocation,
    };
    setLocationData(locationData);
    setOpenMapModal(true);
  };

  const handleInfo = (props) => {
    setPreviewData(props);
    let totalCost = 0;
    props.furnitures.forEach((furniture) => {
      totalCost += furniture.quantity * furniture.price;
    });
    if (props.singleLayerPacking) {
      totalCost += 799;
    }
    if (props.multiLayerPacking) {
      totalCost += 1599;
    }
    if (props.unpacking) {
      totalCost += 799;
    }
    if (props.dismantling) {
      totalCost += 799;
    }
    setPreviewTotalCost(totalCost);
    setPreviewAddOns({
      singleLayerPacking: props.singleLayer,
      dismantling: props.dismantling,
      multiLayerPacking: props.multiLayer,
      unpacking: props.unpacking,
    });
    setOpenModal(true);
  };

  const handlePDFDownload = async (props) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(downloadPDFUrl + props._id, {
        responseType: "blob",
        headers: { Authorization: `Bearer ${token}` },
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${props.name}.pdf`); // Set the filename
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link); // Clean up
    } catch (error) {
      console.error("Error downloading the PDF:", error);
    }
  };

  const columnDefs = [
    {
      headerName: "S.No",
      valueGetter: "node.rowIndex + 1",
      filter: false,
      maxWidth: 70,
    },
    {
      headerName: "Pickup Date",
      field: "pickupDate",
      cellRenderer: (params) => {
        return convertUTCToLocal(params.data.pickupDate, "MMM D, YYYY h:mm A");
      },
    },
    {
      headerName: "Name",
      field: "name",
    },
    {
      headerName: "Mobile",
      field: "mobile",
    },
    {
      headerName: "Email",
      field: "email",
    },
    {
      headerName: "Pickup Location",
      field: "pickupLocation",
      cellRenderer: (params) => {
        return `${params.data.pickupLocationDetails.pickupLocation}`;
      },
    },
    {
      headerName: "Drop Location",
      field: "dropLocation",
      cellRenderer: (params) => {
        return `${params.data.dropLocationDetails.dropLocation}`;
      },
    },
    {
      headerName: "Action",
      cellRenderer: Action,
    },
  ];

  const handleModalClose = () => {
    setOpenModal(false);
  };

  const handleMapModalClose = () => {
    setOpenMapModal(false);
    setLocationData({
      from: "",
      to: "",
    });
  };

  const handleEditOrderOpen = (props) => {
    let totalCost = 0;
    if (props.totalCost) {
      totalCost = props.totalCost;
    } else {
      props.furnitures.forEach((furniture) => {
        totalCost += furniture.quantity * furniture.price;
      });
      if (props.singleLayerPacking) {
        totalCost += 799;
      }
      if (props.multiLayerPacking) {
        totalCost += 1599;
      }
      if (props.unpacking) {
        totalCost += 799;
      }
      if (props.dismantling) {
        totalCost += 799;
      }
    }
    setPreviousTotalCost(totalCost);
    setOrderId(props._id);
    setEditLoadType(props.loadType || "");
    setOpenOrderEditModel(true);
  };

  const handleEditOrderClose = () => {
    setOpenOrderEditModel(false);
  };

  const handleUpdateOrderCost = async (newCost, newLoadType) => {
    try {
      const payload = {
        id: orderId,
      };
      if (newCost !== undefined && newCost !== null && newCost !== "") {
        payload.totalCost = Number(newCost);
        payload.previousCost = previousTotalCost;
      }
      if (newLoadType) {
        payload.loadType = newLoadType;
      }

      const res = await axios.put(
        updateAmountPackingUrl, // No need for trailing slash if URL is complete
        payload,
        getAccessToken()
      );

      if (res.data.status) {
        setSnackbar({
          open: true,
          message: "Order updated successfully!",
        });
        if (payload.totalCost !== undefined) {
          setPreviousTotalCost(Number(newCost));
        }
        if (payload.loadType) {
          setEditLoadType(payload.loadType);
        }
        handleEditOrderClose();
        getOrders();
      }
    } catch (error) {
      console.error("Failed to update order cost", error);
      setSnackbar({
        open: true,
        message: "Failed to update order!",
      });
    }
  };

  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          sx={{ padding: "10px 10px 0px 10px" }}
        >
          <Box p={1}>
            <Button
              variant="outlined"
              startIcon={<CalendarMonthIcon />}
              onClick={() => setOpenScheduleModal(true)}
            >
              Schedule View
            </Button>
          </Box>
          <Box display="flex" alignItems="center">
            <DemoContainer components={["DatePicker"]}>
              <DatePicker
                label="Filter by Pickup Date"
                onChange={(value) => {
                  setFilterDate(value);
                }}
                value={filterDate}
              />
            </DemoContainer>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: 1,
              }}
            >
              <IconButton
                size="small"
                onClick={() => setFilterDate(null)}
                sx={{
                  width: 32,
                  height: 32,
                  padding: 0,
                  borderRadius: "50%",
                  backgroundColor: "#f5f5f5",
                  "&:hover": {
                    backgroundColor: "#e0e0e0",
                  },
                }}
                disabled={!filterDate}
              >
                <ClearIcon fontSize="small" />
              </IconButton>
            </Box>
          </Box>
        </Box>
      </LocalizationProvider>
      {openScheduleModal && (
        <Modal
          open={openScheduleModal}
          setOpen={() => setOpenScheduleModal(false)}
          width="90vw"
        >
          <Box p={2}>
            <Typography variant="h6" color="primary" gutterBottom>
              Schedule view{" "}
              {filterDate
                ? `for ${dayjs(filterDate).format("MMM D, YYYY")}`
                : "(all)"}
            </Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Box
                display="flex"
                gap={2}
                flexWrap="wrap"
                alignItems="center"
                mb={2}
              >
                <Box sx={{ minWidth: 260 }}>
                  <DatePicker
                    label="From date"
                    value={scheduleFromDate}
                    onChange={(v) => setScheduleFromDate(v)}
                  />
                </Box>
                <Box sx={{ minWidth: 260 }}>
                  <DatePicker
                    label="To date"
                    value={scheduleToDate}
                    onChange={(v) => setScheduleToDate(v)}
                  />
                </Box>
                <OutlinedInput
                  placeholder="Search name, mobile, pickup/drop"
                  value={scheduleFilterText}
                  onChange={(e) => setScheduleFilterText(e.target.value)}
                  sx={{ minWidth: 320 }}
                />
                <Button
                  variant="text"
                  onClick={() => {
                    setScheduleFilterText("");
                    setScheduleFromDate(null);
                    setScheduleToDate(null);
                  }}
                >
                  Clear
                </Button>
              </Box>
            </LocalizationProvider>
            {(() => {
              // Base list depends on the main filter at top
              let list = filterDate ? ordersListPickupDate : orders;
              // Apply date range filter if provided
              if (scheduleFromDate) {
                list = list.filter(
                  (o) =>
                    dayjs(o.pickupDate).isSame(scheduleFromDate, "day") ||
                    dayjs(o.pickupDate).isAfter(scheduleFromDate, "day")
                );
              }
              if (scheduleToDate) {
                list = list.filter(
                  (o) =>
                    dayjs(o.pickupDate).isSame(scheduleToDate, "day") ||
                    dayjs(o.pickupDate).isBefore(scheduleToDate, "day")
                );
              }
              // Apply text filter across name, mobile, pickup and drop
              const q = (scheduleFilterText || "").toLowerCase().trim();
              if (q) {
                list = list.filter((o) => {
                  const name = (o.name || "").toLowerCase();
                  const mobile = (o.mobile || "").toLowerCase();
                  const from = (
                    o?.pickupLocationDetails?.pickupLocation || ""
                  ).toLowerCase();
                  const to = (
                    o?.dropLocationDetails?.dropLocation || ""
                  ).toLowerCase();
                  return (
                    name.includes(q) ||
                    mobile.includes(q) ||
                    from.includes(q) ||
                    to.includes(q)
                  );
                });
              }
              const groups = {};
              list.forEach((o) => {
                const key = dayjs(o.pickupDate).format("YYYY-MM-DD");
                if (!groups[key]) groups[key] = [];
                groups[key].push(o);
              });
              const sortedDays = Object.keys(groups).sort((a, b) =>
                a < b ? -1 : 1
              );
              if (sortedDays.length === 0) {
                return (
                  <Typography variant="body2" color="text.secondary">
                    No orders found.
                  </Typography>
                );
              }
              return (
                <Box>
                  {sortedDays.map((dayKey, idx) => {
                    const day = dayjs(dayKey);
                    const items = groups[dayKey].sort(
                      (a, b) =>
                        dayjs(a.pickupDate).valueOf() -
                        dayjs(b.pickupDate).valueOf()
                    );
                    const gcalDayViewUrl = `https://calendar.google.com/calendar/u/0/r/day/${day.format(
                      "YYYY"
                    )}/${day.format("MM")}/${day.format("DD")}`;
                    return (
                      <Box key={dayKey} mb={2}>
                        {idx > 0 && <Divider sx={{ my: 1 }} />}
                        <Box
                          display="flex"
                          alignItems="center"
                          justifyContent="space-between"
                          mb={1}
                        >
                          <Typography variant="subtitle1">
                            {day.format("dddd, MMM D, YYYY")}
                          </Typography>
                          <Button
                            size="small"
                            variant="outlined"
                            onClick={() =>
                              window.open(gcalDayViewUrl, "_blank")
                            }
                          >
                            Open Day View
                          </Button>
                        </Box>
                        <Box sx={{ border: "1px solid #eee", borderRadius: 1 }}>
                          {items.map((o) => {
                            const start = dayjs(o.pickupDate);
                            const end = start.add(2, "hour");
                            const formatGCal = (d) =>
                              d.utc().format("YYYYMMDD[T]HHmmss[Z]");
                            const gcalCreateUrl = `https://calendar.google.com/calendar/render?action=TEMPLATE&dates=${formatGCal(
                              start
                            )}/${formatGCal(end)}&text=${encodeURIComponent(
                              "House Shifting - " + o.name
                            )}&details=${encodeURIComponent(
                              `Pickup: ${
                                o?.pickupLocationDetails?.pickupLocation || ""
                              }\nDrop: ${
                                o?.dropLocationDetails?.dropLocation || ""
                              }\nMobile: ${o.mobile}`
                            )}`;
                            return (
                              <Box
                                key={o._id}
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  p: 1,
                                  borderBottom: "1px dashed #f0f0f0",
                                }}
                              >
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                  }}
                                >
                                  <IconButton
                                    onClick={() => handleInfo(o)}
                                    size="small"
                                  >
                                    <InfoIcon fontSize="small" />
                                  </IconButton>
                                  <IconButton
                                    onClick={() => handlePDFDownload(o)}
                                    size="small"
                                  >
                                    <PictureAsPdfIcon fontSize="small" />
                                  </IconButton>
                                  <Box>
                                    <Typography variant="body2">
                                      <strong>{start.format("h:mm A")}</strong>{" "}
                                      • {o.name} ({o.mobile})
                                    </Typography>
                                    <Typography
                                      variant="caption"
                                      color="text.secondary"
                                    >
                                      From:{" "}
                                      {o?.pickupLocationDetails
                                        ?.pickupLocation || "-"}{" "}
                                      → To:{" "}
                                      {o?.dropLocationDetails?.dropLocation ||
                                        "-"}
                                    </Typography>
                                  </Box>
                                </Box>
                                <Stack direction="row" spacing={1}>
                                  <Button
                                    size="small"
                                    variant="contained"
                                    onClick={() =>
                                      window.open(gcalCreateUrl, "_blank")
                                    }
                                  >
                                    Add Event
                                  </Button>
                                </Stack>
                              </Box>
                            );
                          })}
                        </Box>
                      </Box>
                    );
                  })}
                </Box>
              );
            })()}
            <Box display="flex" justifyContent="flex-end" mt={2}>
              <Button
                variant="contained"
                onClick={() => setOpenScheduleModal(false)}
              >
                Close
              </Button>
            </Box>
          </Box>
        </Modal>
      )}
      {openCalendarModal && calendarOrder && (
        <Modal
          open={openCalendarModal}
          setOpen={handleCalendarClose}
          width="80vw"
        >
          {(() => {
            const start = dayjs(calendarOrder.pickupDate);
            const end = start.add(2, "hour");
            const formatGCal = (d) => d.utc().format("YYYYMMDD[T]HHmmss[Z]");
            const gcalCreateUrl = `https://calendar.google.com/calendar/render?action=TEMPLATE&dates=${formatGCal(
              start
            )}/${formatGCal(end)}&text=${encodeURIComponent(
              "House Shifting - " + calendarOrder.name
            )}&details=${encodeURIComponent(
              `Pickup: ${
                calendarOrder?.pickupLocationDetails?.pickupLocation || ""
              }\nDrop: ${
                calendarOrder?.dropLocationDetails?.dropLocation || ""
              }\nMobile: ${calendarOrder.mobile}`
            )}`;
            const gcalDayViewUrl = `https://calendar.google.com/calendar/u/0/r/day/${start.format(
              "YYYY"
            )}/${start.format("MM")}/${start.format("DD")}`;
            return (
              <Grid container spacing={2} p={2}>
                <Grid item xs={12}>
                  <Typography variant="h6" color="primary">
                    Scheduler view for {start.format("MMM D, YYYY")}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {calendarOrder.name} • {calendarOrder.mobile}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    From:{" "}
                    {calendarOrder?.pickupLocationDetails?.pickupLocation ||
                      "-"}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    gutterBottom
                  >
                    To:{" "}
                    {calendarOrder?.dropLocationDetails?.dropLocation || "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="subtitle1" gutterBottom>
                    Furnitures
                  </Typography>
                  <Box
                    sx={{
                      maxHeight: 300,
                      overflowY: "auto",
                      border: "1px solid #eee",
                      borderRadius: 1,
                      p: 1,
                    }}
                  >
                    {calendarOrder.furnitures &&
                    calendarOrder.furnitures.length > 0 ? (
                      calendarOrder.furnitures
                        .filter((i) => i.quantity > 0)
                        .map((item, idx) => (
                          <Box
                            key={idx}
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              py: 0.5,
                              borderBottom: "1px dashed #f0f0f0",
                            }}
                          >
                            <Typography variant="body2">{item.name}</Typography>
                            <Typography variant="body2" color="text.secondary">
                              x{item.quantity}
                            </Typography>
                          </Box>
                        ))
                    ) : (
                      <Typography variant="body2" color="text.secondary">
                        No items.
                      </Typography>
                    )}
                  </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="subtitle1" gutterBottom>
                    Google Calendar
                  </Typography>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    gutterBottom
                  >
                    Direct embedding may be blocked by the browser. Use the
                    links below to view or add the event in your Google
                    Calendar.
                  </Typography>
                  <Stack direction="row" spacing={2}>
                    <Button
                      variant="outlined"
                      onClick={() => window.open(gcalDayViewUrl, "_blank")}
                    >
                      Open Day View
                    </Button>
                    <Button
                      variant="contained"
                      onClick={() => window.open(gcalCreateUrl, "_blank")}
                    >
                      Add To Google Calendar
                    </Button>
                  </Stack>
                </Grid>
                <Grid
                  item
                  xs={12}
                  display="flex"
                  justifyContent="flex-end"
                  mt={1}
                >
                  <Button variant="contained" onClick={handleCalendarClose}>
                    Close
                  </Button>
                </Grid>
              </Grid>
            );
          })()}
        </Modal>
      )}
      {openModal && (
        <Modal open={openModal} setOpen={handleModalClose}>
          <DisplayOrder
            name={previewData.name}
            email={previewData.email}
            mobile={previewData.mobile}
            serviceLiftAtPickup={previewData.serviceLiftAtPickup}
            serviceLiftAtDrop={previewData.serviceLiftAtDrop}
            pickupDate={convertUTCToLocal(
              previewData.pickupLocationDetails.pickupDate,
              "MMM D, YYYY h:mm A"
            )}
            pickupLocationDetails={previewData.pickupLocationDetails}
            dropLocationDetails={previewData.dropLocationDetails}
            furnitures={previewData.furnitures}
            showPrice={true}
            totalCost={previewTotalCost}
            addOns={previewAddOns}
            housingType={previewData.housingType}
            loadType={previewData.loadType || ""}
            additionalItems={previewData.additionalItems}
            distanceConfig={previewData.distanceConfig}
            distance={previewData.distance}
          />
          <Grid container display="flex" justifyContent="flex-end" mt={2}>
            <Grid xs={2}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                onClick={handleModalClose}
              >
                Close
              </Button>
            </Grid>
          </Grid>
        </Modal>
      )}
      {openMapModal && (
        <Modal open={openMapModal} setOpen={handleMapModalClose}>
          <LocationView locationData={locationData} open={openMapModal} />
          <Grid
            container
            display="flex"
            justifyContent="flex-end"
            mt={2}
            pr={1}
            mb={1}
          >
            <Grid xs={2}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                onClick={handleMapModalClose}
              >
                Close
              </Button>
            </Grid>
          </Grid>
        </Modal>
      )}
      {openOrderEditModel && (
        <Modal open={openOrderEditModel} onClose={handleEditOrderClose}>
          <EditOrderModel
            previousTotalCost={previousTotalCost}
            onClose={handleEditOrderClose}
            onUpdate={handleUpdateOrderCost}
            currentLoadType={editLoadType}
          />
        </Modal>
      )}
      <DataTable
        columnDefs={columnDefs}
        rowData={
          orders &&
          orders.length > 0 &&
          (filterDate === null || filterDate === undefined)
            ? orders
            : filterDate != null &&
              ordersListPickupDate &&
              ordersListPickupDate.length > 0
            ? ordersListPickupDate
            : []
        }
      />
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={snackbar.open}
        onClose={() => {
          setSnackbar({ ...snackbar, open: false });
        }}
        message={snackbar.message}
      />
      <PrimaryLoader openModal={loading} />
    </>
  );
};

export default Listing;
